import { ApplicationState, RootState, Application } from '@/types';
import { GetterTree, MutationTree, ActionTree, Module } from 'vuex';
import ApplicationService from '@/services/application.service';
import { ApplicationMutator } from '@/mutators/application.mutator';

type ApplicationGetter = GetterTree<ApplicationState, RootState>;

export const initialState = (): ApplicationState => {
  return {
    initialState,
    applications: [],
    filters: {},
    total: 0,
  };
};

export const getters: ApplicationGetter = {
  applications: (state) => state,
  applicationById: (state) => (id: string) => state.applications.find((i: Application) => i.id === id),
  applicationsTabular: (state) => state.applications.map(ApplicationMutator.toTabular),
};

export const mutations: MutationTree<ApplicationState> = {
  addApplications(state, newApplications) {
    state.applications = newApplications;
  },
};

export const actions: ActionTree<ApplicationState, RootState> = {
  async addApplicationsAsync(context: any, pagination: {
    take: number, skip: number, sort: string, desc: boolean, filters: object,
  }): Promise<void> {
    const apps = await ApplicationService.getApplications(
      // pagination.take, pagination.skip, pagination.sort, pagination.desc, pagination.filters,
    );
    context.commit('addApplications', apps);
  },
};

export const applications: Module<ApplicationState, RootState> = {
  state: initialState(),
  getters,
  mutations,
  actions,
};
